<template>
    <img src="img/natural_beauty_logo.png"/>
</template>
